import { getDeviceSupportedAbilities } from "@/services/cheers";
import { isAndroid, isiOS, toast } from "@bilibili/growup-utils";
import { biliBridge, isSupport, inBiliApp } from "@bilibili/js-bridge";

export function closeWebview() {
  if (inBiliApp) {
    isSupport("global.closeBrowser").then((support) => {
      if (support) {
        biliBridge.callNative({
          method: "global.closeBrowser"
        });
      } else {
        window.close();
      }
    });
  } else {
    window.close();
  }
}

export function hideNavigation() {
  biliBridge.callNative({
    method: "ui.hideNavigation"
  });
}

export function setScrollBouncesFalse() {
  biliBridge.callNative({
    method: "ui.setScrollBounces",
    data: {
      bounces: false
    }
  });
}
export function saveImage(url: string) {
  isSupport("ability.saveImageToPhotosAlbum").then((support) => {
    if (!support) {
      toast("当前版本过低，请更新至最新版本保存图片哦~");
      return;
    }
    biliBridge.callNative({
      method: "ability.saveImageToPhotosAlbum",
      data: {
        filePath: url
      },
      callback: (info) => {
        if (+info.code === 0) {
          toast("保存成功~");
        }
      }
    });
  });
}

export function openVideo(id: string) {
  biliBridge.callNative({
    method: "ability.openScheme",
    data: {
      url: `bilibili://video/${id}`
    }
  });
}

export function getContainerInfo(cb) {
  biliBridge.callNative({
    method: "global.getContainerInfo",
    callback: (info) => {
      cb(info);
    }
  });
}

export function getUInfo(cb) {
  biliBridge.callNative({
    method: "auth.getUserInfo",
    data: {
      type: "default"
    },
    callback: (userInfo) => {
      cb(userInfo);
      // {
      //   state: 1,   // 0: 未登录, 1: 已登录
      //   mid: 1001,
      //   userName: 'akari',
      //   face: 'http://xx.jpg'
      // }
    }
  });
}

export function showUnsupportedDesc() {
  getDeviceSupportedAbilities((params) => {
    const abilities = params!.abilities;
    if (!params) {
      toast("抱歉，权限获取不到");
      return;
    }
    if (isiOS && abilities.length < 4) {
      toast("当前设备不支持干杯操作");
    }
    if (isAndroid && abilities.length < 5) {
      toast("当前设备不支持干杯操作");
    }
  });
}
